// extracted by mini-css-extract-plugin
export default {"moving":"LoginMarquee_moving__r1Qvb","marquee":"LoginMarquee_marquee__8P7R-"};